import NativeSelect from "@/tpo/NativeSelect";
import ShippingCountrySelect from "@/tpo/ShippingCountrySelect";
import Stack from "@/tpo/Stack";
import sortShippingCountries from "@/utils/sortShippingCountries";

const selectStyles = {
  select: {
    fontSize: [14, 14, 16]
  },
  wrapper: {
    maxWidth: null
  }
};

export default function ExpertsPractitionerLocaleFilters({
  expertCountries = [],
  languages = [],
  countryValue = "",
  languageValue = "",
  onCountryChange,
  onLanguageChange
}) {
  const expertCountryNames = new Set(expertCountries.map(country => country.name));
  const sortedLanguages = [...languages].sort((a, b) => a.name.localeCompare(b.name));

  if (!expertCountries.length && !languages.length) {
    return null;
  }

  return (
    <Stack gap={16}>
      {!!expertCountries.length && (
        <ShippingCountrySelect
          name="expertCountry"
          label=""
          placeholder="Select a country"
          valueField="name"
          fullWidth
          value={countryValue}
          getOptions={shippingCountries =>
            sortShippingCountries(
              shippingCountries.filter(country => expertCountryNames.has(country.name))
            ).map(item => ({
              value: item.name,
              label: item.name
            }))
          }
          onChange={onCountryChange}
        />
      )}
      {!!languages.length && (
        <NativeSelect
          name="expertLanguage"
          label=""
          value={languageValue}
          onChange={onLanguageChange}
          styles={selectStyles}
        >
          <option value="">Select a language</option>
          {sortedLanguages.map(language => (
            <option key={language.id} value={language.name}>
              {language.name}
            </option>
          ))}
        </NativeSelect>
      )}
    </Stack>
  );
}
